<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
            <v-card-title>Host booking accept / deny</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-row>
                    <v-col cols="12">Host booking {{ heho.heho_code }}</v-col>
                </v-row>
                <v-divider/>
                <v-row>
                    <v-col cols="12"><v-textarea v-model="heho.stay_remarks" disabled label="Host remarks"></v-textarea></v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"><v-textarea v-model="heho.result" label="Book or deny reason/remark"></v-textarea></v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <span v-if="heho.result.length<6">Please give a reasen to allow/deny this booking</span>
                <v-spacer></v-spacer>
                <v-btn color="primary mx-2" small @click="updHehoBknDny('bkn')" :disabled="heho.result.length<6">Book</v-btn>
                <v-btn color="primary mx-2" small @click="updHehoBknDny('dny')" :disabled="heho.result.length<6">Deny</v-btn>
                <v-btn color="primary"      small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                heho: {
                    heho_code: "",
                    stay_remarks: "",
                    result: "",
                },
            }
        },
        methods: {
            openDialog(heho_encrid) {
                this.getHehoBknDeny(heho_encrid);
            },
            getHehoBknDeny(heho_encrid) {
                this.$axios.post("ares/json/ares/heho/getHehoBknDeny.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHehoBknDeny",
                    },
                    getHehoBknDeny: {
                        heho_encrid: heho_encrid
                    },
                }).then((res) => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.heho = res.data.getHehoBknDeny;
                        if (this.heho.hust_code !== "A-STD") {
                            this.$emit("actionClick", "Refresh");
                        } else {
                            this.dialog = true;
                        }
                    }
                });
            },
            updHehoBknDny(bknDny) {
                this.$axios.post("ares/json/ares/heho/updHehoBknDny.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHehoBknDny",
                    },
                    updHehoBknDny: {
                        heho_encrid: this.heho.heho_encrid,
                        heho_bkn_dny: bknDny,
                        heho_result: this.heho.result,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.updHehoBknDny.text,
                            color: res.data.updHehoBknDny.color,
                        });
                        if (res.data.updHehoBknDny.color == "success" || res.data.updHehoBknDny.color == "warning" ) {
                            this.$emit("actionClick", "Refresh");
                            this.dialog = false; 
                        }
                    }
                });
            },
        }
    }
</script>

